import React from 'react';
import { Button } from 'primereact/button';
import { useLazyExportDealerProcessingToExcelQuery } from '../../../api/endpoints/dealerProcessingReport';
import { useLanguage } from '../../../contexts/LanguageContext';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';
import DealerProcessingReportTable from './component/DealerProcessingReportTable';
import useDealerProcessingReportData from './hook/useDealerProcessingReportData';

const DealerProcessingReportPage = () => {
    const { th } = useLanguage();
    const { apiData, isLoading, lazyParams, sortField, sortOrder, activeFilters, onPage, onSort, handleFilterChange, initFilters, exportParams } = useDealerProcessingReportData();

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('dealerProcessingReport.title')}</h1>
                <div className="flex gap-2">
                    <Button icon="pi pi-filter-slash" className="p-button-outlined p-button-secondary" onClick={initFilters} tooltip={th('filter.reset')} tooltipOptions={{ position: 'left' }} />
                    <GenericFileExportButton
                        useExportQuery={useLazyExportDealerProcessingToExcelQuery}
                        exportParams={exportParams}
                        buttonLabel="Excel"
                        buttonClassName="p-button-success"
                        icon="pi pi-file-excel"
                        fileNameExtractor={(result) => result?.fileName || 'bayi_islem_raporu.xlsx'}
                        dataExtractor={(result) => result?.fileBase64}
                        contentTypeExtractor={(result) => result?.contentType}
                    />
                </div>
            </div>
            <DealerProcessingReportTable
                items={apiData?.items ?? []}
                totalCount={apiData?.totalCount ?? 0}
                loading={isLoading}
                lazyParams={lazyParams}
                onPage={onPage}
                activeFilters={activeFilters}
                onFiltersChange={handleFilterChange}
                sortField={sortField}
                sortOrder={sortOrder}
                onSortChange={onSort}
            />
        </div>
    );
};

export default DealerProcessingReportPage;
